export const MUTATION_TYPE_LABEL = "mutation type";
export const MUTATION_TYPE_KEY = "mutation_type";
export const LIN_SUB_ABBREVIATION = "lin_sub_abbreviation";
export const LINEAGE_LABEL = "lineage";
export const SUB_LINEAGE_LABEL = "lineage_subtype";
export const LIN_ABBREVIATION = "lin_abbreviation";

// export const API_COMPOPUND_PARAMS = {
//     screen: this.$route.params.screen,
//     project: this.$route.params.project,
//     pert_plate: this.$route.params.pert_plate,
//     pert_id: this.$route.params.pert_id
// }

export function getPageDrawerFromId(page_id) {
    return pageSections[page_id].drawer ? pageSections[page_id].drawer : `${page_id}-drawer`
}

export function getSideBarLinks(section_id, params) {
    const section = pageSections[section_id]
    if (section.children){
        return {
            title: section.title,
            link: {
                name: 'CompoundPage',
                params: {
                    screen: params.screen,
                    project: params.project,
                    pert_plate: params.pert_plate,
                    pert_id: params.pert_id,
                    tab: section.path, // default subtab
                }
            },
            children: section.children.map(subitem=>{
                const subsection = pageSections[subitem]
                return {
                    title: subsection.title || subitem,
                    link: {
                        name: 'CompoundPage',
                        params: {
                            screen: params.screen,
                            project: params.project,
                            pert_plate: params.pert_plate,
                            pert_id: params.pert_id,
                            tab: subsection.path ? subsection.path : subitem,
                        }
                    }
                }
            })
        }
    } else {
        const section = pageSections[section_id]
        return {
            title: section.title,
            link: {
                name: 'CompoundPage',
                params: {
                    screen: params.screen,
                    project: params.project,
                    pert_plate: params.pert_plate,
                    pert_id: params.pert_id,
                    tab: section.path,
                    subtab:null
                }
            }
        }
    }
}


export const pageSections = {
    "overview": {title: "Overview", path: "overview"},
    "synergy-by-dose": {title: "Synergy by Dose", path: "synergy-by-dose"},
    "continuous-associations": {title: "Continuous Associations", path: "continuous-associations"},
    "random-forest-models": {title: "Random Forest Models", path: "random-forest-models"},
    "viability-heatmap": {title: "Viability Heatmap", path: "viability-heatmap"},
    "dose-response": {title: "Dose Response", path: "dose-response"},
    "lineage-enrichment": {title: "Lineage Enrichment", path: "lineage-enrichment",
        children: [
            "lineage-enrichment-volcano-plots",
            "lineage-enrichment-box-plots",
        ],
        titlePage: "Lineage Enrichment - Volcano Plots",
    },
    "mutation-effect": {title: "Mutation Effect", path: "mutation-effect",
        children: [
            "mutation-effect-volcano-plots",
            "mutation-effect-box-plots",
        ],
        titlePage: "Mutation Effect - Volcano Plots",
    },
    "lineage-enrichment-volcano-plots": {title: "Volcano Plots", path: "lineage-enrichment",
        titlePage: "Lineage Enrichment - Volcano Plots",
    },
    "lineage-enrichment-box-plots": {title: "Box Plots", path: "lineage-enrichment-box-plots",
        titlePage: "Lineage Enrichment - Box Plots",
        drawer: "lineage-enrichment-drawer"},
    "mutation-effect-volcano-plots": {title: "Volcano Plots", path: "mutation-effect",
        titlePage: "Mutation Effect - Volcano Plots",
    },
    "mutation-effect-box-plots": {title: "Box Plots", path: "mutation-effect-box-plots",
        drawer: "mutation-effect-drawer",
        titlePage: "Mutation Effect - Box Plots",
    },
    "correlation-analysis": {title: "Correlation Analysis", path: "correlation-analysis"},
    "multivariate-biomarker-analysis": {title: "Multivariate Biomarker Analysis", path: "multivariate-biomarker-analysis"},
    "compounds": {title: "Compounds", path: "compounds"},
    "downloads": {title: "Downloads", path: "downloads"},
    "qc": {title: "Quality Control", path: "qc"},
    "data-processing": {title: "Data Processing", path: "data-processing"},

}


export const sectionTitles = {
  "compounds": "Compounds",
  "downloads": "Downloads",
  "qc": "Quality Control",
  "data-processing": "Data Processing",
  "overview":"Overview",
  "viability-heatmap": "Viability Heatmap",
  "dose-response": "Dose Response",
  "lineage-enrichment-volcano-plots": "Volcano Plots",
  "lineage-enrichment": "Lineage Enrichment",
  "lineage-enrichment-box-plots": "Box Plots",
  // "lineage-enrichment": "Lineage Enrichment",
  // "volcano-plots": "Volcano Plots",
  // "boxplots": "Boxplots",
  "mutation-effect": "Mutation Effect Volcano Plots",
  "mutation-effect-box-plots": "Mutation Effect Box Plots",
  "correlation-analysis": "Correlation Analysis",
  "multivariate-biomarker-analysis": "Multivariate Biomarker Analysis",
  "sensitivity-comparison": "Sensitivity Comparison",
  "continuous-associations": "Continuous Associations",
  "random-forest-models": "Random Forest Models",
  "synergy-by-dose": "Synergy by Dose",
  "auc-plots": "AUC Plots"
}


export const eps_qc_file = `https://assets.clue.io/portal-testing/qc_table.csv`;